export default "__VITE_ASSET__Dm7twSs9__"